export default "https://cdn-static.gokick.com/assets/ecb6814e4f4fd856ee5e2a82e5f087b2e6d90ad2/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";